import { createSelector } from 'reselect';
import { pendingResponse } from '../fetchStatus';
import { markenStandortSelector } from './standort/markenStandort';

const merklisteSelector = state => state.merkliste.merkliste
const merklisteProductSelector = state => state.merkliste.merklistenProducts;
const unavailableProductsSelector = state => state.merkliste.unavailableProducts || [];

export const merklistenResponseSelector = createSelector([merklisteSelector], (merkliste) => { 
    return merkliste});
export const merklistenSelector = createSelector([merklistenResponseSelector], merkliste => {
    return merkliste?.data ?? [];
});

export const merklistenProductResponseSelector = createSelector([merklisteProductSelector], (merklistenProducts) => {
    return merklistenProducts?.data ? merklistenProducts : pendingResponse});

export const merklistenProductSelector = createSelector([merklisteProductSelector], (merklistenProducts) => {
    return merklistenProducts?.data});

export const availableMerklistenCountSelector = createSelector(
    [merklistenSelector, unavailableProductsSelector, markenStandortSelector],
    (merkliste, unavailableProducts, markenStandort) => {
        if (!Array.isArray(merkliste) || !markenStandort?._id) {
            return 0;
        }

        const unavailableIds = new Set(
            (unavailableProducts || []).map(id => String(id))
        );

        return merkliste.filter(entry => {
            if (String(entry.standort) !== String(markenStandort._id)) {
                return false;
            }

            const entryIds = [entry.productId, entry.selectedVariant]
                .filter(id => id != null && id !== '')
                .map(id => String(id));

            return !entryIds.some(id => unavailableIds.has(id));
        }).length;
    }
);
